import { DisclosureGroupingsProps } from './types';
import type { DisclosureProps } from 'libs/contentful/types';
import Disclosure from './Disclosure';
import KeyLine from 'components/shared/KeyLine';
import { getYMarginsSlim } from 'utils/styles';

const DisclosureGroupings = ({ sectionName, disclosures, showKeyline, margins }: DisclosureGroupingsProps) => {
  const items = disclosures?.items || [];
  const gap = '2';

  return (
    <>
      {items.length > 0 && (
        <div className={`mb-${gap} disclosure-groupings`} data-testid="disclosure-groupings">
          <div className={`content-wrapper`}>
            {showKeyline && <KeyLine />}
            <div {...(sectionName != null && { id: encodeURIComponent(sectionName) })}>
              <div className={`flex flex-col gap-y-${gap} ${getYMarginsSlim(margins)}`}>
                {items.map((disclosure: DisclosureProps, index: number) => {
                  return <Disclosure key={index} {...disclosure} />;
                })}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DisclosureGroupings;
